<template>
  <div>
    <v-container pa-0>
      <v-layout row py-0>
        <v-flex xs12 md10 offset-md1>
          <v-container grid-list-md text-xs-center pa-0>
            <v-progress-linear
              :active="loading"
              height="3"
              class="my-0"
              :indeterminate="true"
            />
            <v-layout row py-0>
              <v-spacer />
              <v-menu
                v-model="filterMenu"
                :close-on-content-click="false"
                :nudge-width="200"
                offset-x
              >
                <template #activator="{ on }">
                  <v-btn flat icon v-on="on">
                    <v-icon>tune</v-icon>
                  </v-btn>
                </template>

                <v-card>
                  <v-layout wrap row pa-3>
                    <v-flex xs12 px-2>
                      <v-select
                        v-model="phaseFilter"
                        :items="phases.map((item) => item.name)"
                        clearable
                        :label="
                          $t('action.actions.select', {
                            field: $tc('models.phase'),
                          })
                        "
                      />
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-menu>
              <v-btn
                icon
                :loading="loading"
                @click="fetchRankingByGroup(tournamentId)"
              >
                <v-icon class="text--secondary"> refresh </v-icon>
              </v-btn>
            </v-layout>
            <v-layout
              v-for="(phase, index1) in phases.filter(
                (item) => !phaseFilter || item.name == phaseFilter
              )"
              :key="phase._id"
              row
              wrap
              py-0
              mb-4
            >
              <v-flex xs12 px-2 py-0>
                <v-card>
                  <v-card-text class="px-0 py-1 primary white--text">
                    <v-flex text-xs-center>
                      <v-layout row wrap align-center justify-center>
                        <span class="headline">{{ phase.name }}</span>
                        <v-btn
                          v-if="
                            can('edit', 'tournament', tournament) &&
                            isValidPhase(phase)
                          "
                          flat
                          dark
                          :loading="loadingRM == phase._id"
                          @click="ifSetRandomMatches(phase._id)"
                        >
                          {{ $t('fields.tournaments.randomMatches') }}
                        </v-btn>
                      </v-layout>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex
                v-for="group in phase.groups"
                :key="group._id"
                px-2
                py-3
                xs12
              >
                <v-card color="grey lighten-5">
                  <v-toolbar flat dense color="secondary" dark>
                    <v-toolbar-title>{{ group.name }}</v-toolbar-title>
                    <v-spacer />
                    <v-toolbar-items>
                      <v-btn
                        v-if="can('edit', 'tournament', tournament)"
                        flat
                        icon
                        dark
                        @click="setNew(phase, group)"
                      >
                        <v-icon>add</v-icon>
                      </v-btn>
                    </v-toolbar-items>
                  </v-toolbar>

                  <v-card-text class="body-1 py-0">
                    <template v-for="(match, index) in group.matches">
                      <v-layout
                        :key="match._id"
                        row
                        wrap
                        py-1
                        align-content-center
                      >
                        <v-flex xs2 align-self-center>
                          {{ getWtzDate(match) }}
                        </v-flex>
                        <!-- <template v-if="tournament.type === 'teams'"> -->
                        <template>
                          <v-flex xs3 pl-3 text-xs-left>
                            <v-chip v-if="match.homeTeamId" color="transparent">
                              <v-avatar>
                                <img :src="match.homeTeamId.logo" />
                              </v-avatar>
                              <v-list-tile-content>
                                <v-list-tile-title class="body-1">
                                  {{ match.homeTeamId.name }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title
                                  class="caption grey--text text--lighten-1 text-truncate"
                                >
                                  {{ match.homeTeamId.categories.join(' - ') }}
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-chip>
                          </v-flex>
                          <v-flex xs2 px-0 mx-0 align-self-center>
                            <template v-if="phase.showResults">
                              <span class="body-1 font-weight-bold">{{
                                match.finalScoreHomeTeam
                              }}</span>
                            </template>
                            <template v-else>
                              <i
                                v-if="
                                  match.finalScoreHomeTeam >
                                  match.finalScoreVisitTeam
                                "
                                class="success--text icon material-icons subheading"
                                >check_circle</i
                              >
                              <i
                                v-else-if="
                                  match.finalScoreHomeTeam <=
                                  match.finalScoreVisitTeam
                                "
                                class="error--text icon material-icons subheading"
                                >cancel</i
                              >
                              <span v-else>-</span>
                            </template>
                            <!-- </v-flex>
                            <v-flex xs1 align-self-center>-->

                            <template v-if="phase.showResults">
                              <span>-</span>
                              <span class="body-1 font-weight-bold">{{
                                match.finalScoreVisitTeam
                              }}</span>
                            </template>
                            <template v-else>
                              <i
                                v-if="
                                  match.finalScoreVisitTeam >
                                  match.finalScoreHomeTeam
                                "
                                class="success--text icon material-icons subheading"
                                >check_circle</i
                              >
                              <i
                                v-else-if="
                                  match.finalScoreVisitTeam <=
                                  match.finalScoreHomeTeam
                                "
                                class="error--text icon material-icons subheading"
                                >cancel</i
                              >
                              <span v-else>-</span>
                            </template>
                          </v-flex>
                          <v-flex xs3 text-xs-left>
                            <v-chip
                              v-if="match.visitorTeamId"
                              color="transparent"
                            >
                              <v-avatar>
                                <img :src="match.visitorTeamId.logo" />
                              </v-avatar>
                              <v-list-tile-content>
                                <v-list-tile-title class="body-1">
                                  {{ match.visitorTeamId.name }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title
                                  class="caption grey--text text--lighten-1 text-truncate"
                                >
                                  {{
                                    match.visitorTeamId.categories.join(' - ')
                                  }}
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-chip>
                          </v-flex>
                          <v-flex xs2 align-self-center>
                            <v-icon
                              v-if="
                                can('edit', 'tournament', tournament) ||
                                can('edit', 'match', match)
                              "
                              color="success"
                              class="mr-1 subheading"
                              @click="setOne(phase, group, match._id)"
                            >
                              edit
                            </v-icon>
                            <v-icon
                              v-if="
                                can('edit', 'tournament', tournament) ||
                                can('delete', 'match', match)
                              "
                              color="error"
                              class="subheading"
                              @click="ifDelete(phase, group, match._id)"
                            >
                              delete
                            </v-icon>
                          </v-flex>
                        </template>
                        <!-- <template v-else>
                    <v-flex xs6 align-self-center>{{match.userName}}</v-flex>
                    <v-flex xs2 align-self-center>
                      <template v-if="phase.showResults && match.canOpen">
                        <span class="body-1 font-weight-bold">{{match.userResult}}</span>
                      </template>
                    </v-flex>
                    <v-flex xs2 align-self-center>
                      <v-btn
                        v-if="match.canOpen"
                        flat
                        small
                        icon
                        color="primary"
                        style="width:0px"
                        class="my-0"
                      >
                        <v-icon class="icon material-icons subheading">visibility</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="can('edit', 'tournament', tournament) ||  can('edit', 'match', match)"
                        flat
                        icon
                        small
                        color="success"
                        style="width:0px"
                        class="my-0"
                      >
                        <v-icon class="icon material-icons subheading">create</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="can('edit', 'tournament', tournament) || can('delete', 'match', match)"
                        flat
                        icon
                        small
                        color="error"
                        style="width:0px"
                        class="my-0"
                      >
                        <v-icon class="icon material-icons subheading">delete</v-icon>
                      </v-btn>
                    </v-flex>
                        </template>-->
                      </v-layout>
                      <v-divider
                        v-if="index + 1 < group.matches.length"
                        :key="`divider-${index}`"
                      />
                    </template>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-divider
                v-if="index1 + 1 < phases.length"
                :key="`divider-phases-${index1}`"
                class="mt-3"
              />
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
    <form-match
      ref="form"
      :dialog="dialog"
      :tournament="tournament"
      :phase="phase"
      :group="group"
      tournament-view
      @close="dialog = false"
      @created="updateGroup"
      @updated="fetchOneTournament(tournamentId)"
    />
    <dialog-delete
      :dialog.sync="dialogDelete"
      :loading="$store.state.groups.loading"
      @delete="_setDelete(idDelete)"
    />
    <dialog-confirm
      v-model="dialogRandom"
      :loading="!!loadingRM"
      :text="$t('titles.tournaments.confirmRandom')"
      @submit="_setRandomMatches(idRandom)"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import FormMatch from '@/components/apps/matches/FormManager'
import DialogConfirm from '@/components/widgets/dialog/DialogConfirm'
import DialogDelete from '@/components/widgets/dialog/DialogDelete'
import { formatDate } from '@/helpers/dateHelper'

export default {
  name: 'TabGroupMatches',
  components: {
    FormMatch,
    DialogDelete,
    DialogConfirm,
  },
  props: {
    tournament: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      dialogDelete: false,
      dialogRandom: false,

      filterMenu: false,
      phaseFilter: '',
      idDelete: '',
      idRandom: '',
      edit: true,

      loadingRM: false,

      phase: {},
      group: {},
    }
  },
  computed: {
    ...mapState({
      tournamentId: (state) => state.tournaments.idSelected,
      loading: (state) => state.tournaments.loading,
      rankingByGroup: (state) => state.tournaments.rankingByGroup,
    }),

    phases() {
      if (!this.rankingByGroup || !this.rankingByGroup.phases) return []
      return this.rankingByGroup.phases
    },
  },
  methods: {
    ...mapActions({
      fetchOneMatch: 'matches/fetchOne',
      fetchOneTournament: 'tournaments/fetchOne',
      resetMatch: 'matches/reset',
      setDeleteMatch: 'matches/setDelete',
      addOrDelMatch: 'groups/addOrDelMatch',
      fetchRankingByGroup: 'tournaments/fetchRankingByGroup',
      setRandomMatches: 'phases/setRandomMatches',
    }),

    setNew(phase, group) {
      this.resetMatch()
      this.phase = phase
      this.group = group
      this.$nextTick(() => {
        this.dialog = true
      })
    },
    setOne(phase, group, matchId) {
      this.resetMatch()
      this.phase = phase
      this.group = group
      this.fetchOneMatch(matchId).then(() => {
        this.$nextTick(() => {
          this.dialog = true
        })
      })
    },
    ifDelete(phase, group, matchId) {
      this.idDelete = matchId
      this.phase = phase
      this.group = group
      this.dialogDelete = true
    },
    _setDelete(_id) {
      // this.setDeleteMatch(id).finally(result => {
      this.updateGroup({ _id }, false)
      // this.dialogDelete = false
      // })
    },
    updateGroup(match, add = true) {
      let payload = {
        phaseId: this.phase._id,
        groupId: this.group._id,
        matchId: match._id,
        add,
      }

      this.addOrDelMatch(payload)
        .then(() => {
          this.phase = {}
          this.group = {}
        })
        .finally(() => {
          this.dialogDelete = false
        })
    },
    ifSetRandomMatches(phaseId) {
      this.idRandom = phaseId
      this.dialogRandom = true
    },
    _setRandomMatches(phaseId) {
      this.loadingRM = phaseId
      this.setRandomMatches(phaseId)
        .then(() => {
          this.dialogRandom = false
          this.idRandom = ''
        })

        .finally(() => {
          this.loadingRM = ''
        })
    },
    isValidPhase(phase) {
      return (
        phase.randomMatches &&
        !phase.groups.some((group) =>
          group.matches.some((match) => match.ended)
        )
      )
    },
    getWtzDate(match) {
      // return getWtzDate(match, true, true)
      return formatDate(match.date) + ' ' + match.time
    },
  },
}
</script>

<style scoped lang="scss">
.container {
  max-width: none !important;
}

.success--text {
  color: green;
}

.error--text {
  color: red;
}
</style>
